module.exports = __webpack_public_path__ + "assets/img/btn-download-google-play-442eff12.png";